import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { BlacklistLicensePlateDTO, ControlPlateType, ParkingTariffDTO } from 'src/app/base/models/models.swagger.generated';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ClientService } from 'src/app/base/services/client/client.service';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { BlacklistFormType } from './blacklist-form/blacklist-form-type';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { BlacklistFormComponent } from './blacklist-form/blacklist-form.component';

@Component({
    selector: 'app-tariff-details-blacklist',
    templateUrl: './tariff-details-blacklist.component.html',
    styleUrls: ['./tariff-details-blacklist.component.scss'],
    imports: [
        GridModule,
        TranslateModule,
        ToolbarModule,
        BlacklistFormComponent
    ]
})

export class TariffDetailsBlacklistComponent extends GridBaseComponent implements OnInit {

  @Input() blacklist: BlacklistLicensePlateDTO[];

  @Output() blacklistLicensePlatesChange = new EventEmitter<BlacklistLicensePlateDTO[]>();

  private newItemIndexCount = -1;

  public commands: CommandModel[] = [{
    type: SfCommandButtonType.Delete,
    buttonOption: {
      cssClass: 'icon-btn',
      iconCss: 'icon-trash-can e-icons e-danger',
    },
  }];

  constructor(translateService: TranslateService,
    clientService: ClientService,
    private fb: FormBuilder) {
    super(clientService, translateService, null);
  }

  ngOnInit() {
    this.addDialogTitle = 'i18n.domain.parker-administration.add-tag';
    this.addIndexFindColumnName = 'Id';
    this.addDialogTitle = 'i18n.domain.administration.tariff-details.blacklist-tab.edit-dialog-title';
    this.editSettings.allowEditing = false;
  }

  public override actionComplete(args) {
    super.actionComplete(args);
    if (args.action === 'add' && args.requestType === 'save' || args.requestType === 'delete') {
      this.blacklistLicensePlatesChange.emit(this.blacklist);
    }

  }

  public formatControlPlateType(data): string {
    return 'i18n.shared.controlPlateType.' + ControlPlateType[data.controlPlateType];
  }

  protected initializeEditForm(data: BlacklistLicensePlateDTO): void {
    this.gridEditForm = this.fb.group<BlacklistFormType>({
      id: this.fb.control(data.id || 0),
      countryCode: this.fb.control(data.countryCode || 'CH', [Validators.required]),
      controlPlateType: this.fb.control(data.controlPlateType),
      controlPlateNumber: this.fb.control(data.controlPlateNumber, [Validators.required, Validators.maxLength(10)]),
    });
  }

  protected getEditDialogTitleParams(rowData: any): any {
    return { params: '' };
  }

  protected override getDataToSave(): any {
    const data = this.gridEditForm.getRawValue();
    if (data.id === 0) {
      data.id = this.newItemIndexCount;
      this.newItemIndexCount = this.newItemIndexCount - 1;
    }
    if (data.controlPlateNumber) {
      data.controlPlateNumber = data.controlPlateNumber.trim().replace(/\s+/g, '').toUpperCase();
    }
    return data;
  }
}
